class PersonService {
  constructor(serviceBase) {
    this.serviceBase = serviceBase;
  }

  getList(params) {
    return this.serviceBase.getList(params);
  }

  get(accessLogId) {
    return this.serviceBase.get(accessLogId);
  }

  searchByImage(data) {
    return this.serviceBase.postResourceAction('search-by-image', data);
  }
}

export default PersonService;



// WEBPACK FOOTER //
// ./src/services/PersonService.js